/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('DOMContentLoaded', function () {
  var header = document.querySelector('.header--inline-menu-search');
  if (!header) return;

  var mobileNav = header.querySelector('.header__mobile-nav');
  if (!mobileNav) return;

  var menu = mobileNav.querySelector('.mobile-menu');
  var toggle = mobileNav.querySelector('[data-action="toggle-menu"][aria-controls="' + (menu ? menu.id : '') + '"]');
  if (!menu || !toggle) return;

  var isOpen = false;

  function computeMaxHeight() {
    var headerEl = document.querySelector('.header');
    if (!headerEl) return;
    var bottom = headerEl.getBoundingClientRect().bottom;
    menu.style.maxHeight = (window.innerHeight - bottom) + 'px';
  }

  function openMenu() {
    isOpen = true;
    toggle.setAttribute('aria-expanded', 'true');
    menu.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-mobile-scroll');
    computeMaxHeight();
  }

  function closeMenu() {
    isOpen = false;
    toggle.setAttribute('aria-expanded', 'false');
    menu.setAttribute('aria-hidden', 'true');
    menu.style.maxHeight = '';
    document.body.classList.remove('no-mobile-scroll');
  }

  toggle.addEventListener('click', function (e) {
    e.preventDefault();
    (isOpen || menu.getAttribute('aria-hidden') === 'false') ? closeMenu() : openMenu();
  });

  // Support opening/closing nested panels in the mobile menu on tablet widths
  mobileNav.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-action="open-panel"]');
    if (openBtn && mobileNav.contains(openBtn)) {
      e.preventDefault();
      var controls = openBtn.getAttribute('aria-controls');
      if (controls) {
        openBtn.setAttribute('aria-expanded', 'true');
        var panel = mobileNav.querySelector('#' + CSS.escape(controls));
        if (panel) panel.classList.add('is-open');
      }
      return;
    }

    var closeBtn = e.target.closest('[data-action="close-panel"]');
    if (closeBtn && mobileNav.contains(closeBtn)) {
      e.preventDefault();
      var panelToClose = closeBtn.closest('.mobile-menu__panel.is-open');
      if (panelToClose) {
        panelToClose.classList.remove('is-open');
        var trigger = mobileNav.querySelector('[aria-controls="' + panelToClose.id + '"]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      }
    }
  });

  window.addEventListener('resize', function () {
    if (isOpen || menu.getAttribute('aria-hidden') === 'false') {
      computeMaxHeight();
    }
  });

  // Handle search bar visibility for inline menu search layout
  var searchToggle = header.querySelector('[data-action="toggle-search"]');
  var searchContainer = document.querySelector('.inline-search-container');
  
  if (searchToggle && searchContainer) {
    var isSearchVisible = false;
    
    searchToggle.addEventListener('click', function(e) {
      e.preventDefault();
      
      if (isSearchVisible) {
        searchContainer.style.display = 'none';
        searchToggle.setAttribute('aria-expanded', 'false');
        isSearchVisible = false;
      } else {
        searchContainer.style.display = 'block';
        searchToggle.setAttribute('aria-expanded', 'true');
        isSearchVisible = true;
        
        // Focus on search input after a short delay
        setTimeout(function() {
          var searchInput = searchContainer.querySelector('.search-bar__input');
          if (searchInput) {
            searchInput.focus();
          }
        }, 100);
      }
    });
    
    // Close search when clicking outside
    document.addEventListener('click', function(e) {
      if (isSearchVisible && !searchContainer.contains(e.target) && !searchToggle.contains(e.target)) {
        searchContainer.style.display = 'none';
        searchToggle.setAttribute('aria-expanded', 'false');
        isSearchVisible = false;
      }
    });
    
    // Close search on escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && isSearchVisible) {
        searchContainer.style.display = 'none';
        searchToggle.setAttribute('aria-expanded', 'false');
        isSearchVisible = false;
      }
    });
  }
});

// Make specific desktop dropdown parent non-clickable: "Featured Collections" linking to /collections
function disableFeaturedCollectionsParent() {
  try {
    var anchors = document.querySelectorAll('a.nav-dropdown__link.link[data-type="menuitem"]');
    var labelsToDisable = ['Featured Collections', 'Beloved Brands'];
    anchors.forEach(function(a){
      var text = (a.textContent || '').trim();
      var href = (a.getAttribute('href') || '').trim();
      try { href = new URL(href, window.location.origin).pathname; } catch(e) {}
      var root = (window.routes && window.routes.rootUrlWithoutSlash) ? window.routes.rootUrlWithoutSlash : '';
      var isCollectionsIndex = (href === '/collections' || href === (root + '/collections'));
      if (labelsToDisable.indexOf(text) !== -1 && isCollectionsIndex) {
        a.setAttribute('href', '#');
        a.setAttribute('aria-disabled', 'true');
        a.addEventListener('click', function(e){ e.preventDefault(); });
      }
    });
  } catch (e) {}
}

document.addEventListener('DOMContentLoaded', disableFeaturedCollectionsParent);
document.addEventListener('cart:rerendered', disableFeaturedCollectionsParent);
document.addEventListener('shopify:section:load', disableFeaturedCollectionsParent);
document.addEventListener('cart:refresh', disableFeaturedCollectionsParent);
document.addEventListener('product:rerender', disableFeaturedCollectionsParent);

/* =========================================== */
/* DYNAMIC FABRIC DETAILS TEXT */
/* =========================================== */
// Function to update fabric details text based on material selection
function updateFabricDetailsText() {
  // Find the Material option selector
  const materialSelector = document.querySelector('select[name="option1"]');
  
  if (!materialSelector) return;
  
  // Get the currently selected option text
  const selectedOption = materialSelector.options[materialSelector.selectedIndex];
  const selectedText = selectedOption.text;
  
  // Find all instances of the fabric details text in the product description
  const productDescription = document.querySelector('.product-block-list__item--description .rte, .product-meta__description .rte');
  
  if (productDescription) {
    let descriptionText = productDescription.innerHTML;
    
    // Check if the selected material is "Eco Canvas"
    if (selectedText === 'Eco Canvas') {
      // Replace the original text with "Made in the USA"
      descriptionText = descriptionText.replace(
        /Printed in the USA of imported material\./g,
        'Made in the USA.'
      );
    } else {
      // Replace "Made in the USA" with the original text if it was previously changed
      descriptionText = descriptionText.replace(
        /Made in the USA\./g,
        'Printed in the USA of imported material.'
      );
    }
    
    // Update the description
    productDescription.innerHTML = descriptionText;
  }
}

// Initialize the fabric details text when the page loads
document.addEventListener('DOMContentLoaded', function() {
  updateFabricDetailsText();
  
  // Add event listener to the Material selector
  const materialSelector = document.querySelector('select[name="option1"]');
  if (materialSelector) {
    materialSelector.addEventListener('change', updateFabricDetailsText);
  }
  
  // Also listen for clicks on the select wrapper (for custom dropdowns)
  const selectWrappers = document.querySelectorAll('.select-wrapper--primary');
  selectWrappers.forEach(wrapper => {
    wrapper.addEventListener('click', function() {
      // Wait a bit for the selection to update, then update the text
      setTimeout(updateFabricDetailsText, 100);
    });
  });
});

// Listen for changes when the product form is updated (for dynamic updates)
document.addEventListener('product:updated', function() {
  setTimeout(updateFabricDetailsText, 100);
});

// Listen for URL changes (when variants are selected via URL)
// Avoid a document-wide MutationObserver (major TBT cost); popstate covers History API.
let lastUrl = location.href;
function checkFabricDetailsUrlChange() {
  const url = location.href;
  if (url !== lastUrl) {
    lastUrl = url;
    setTimeout(updateFabricDetailsText, 200);
  }
}
window.addEventListener('popstate', checkFabricDetailsUrlChange);
document.addEventListener('variant:changed', checkFabricDetailsUrlChange);
document.addEventListener('variant:change', checkFabricDetailsUrlChange);

// Also listen for any changes to the product form
document.addEventListener('change', function(event) {
  if (event.target.name === 'option1') {
    setTimeout(updateFabricDetailsText, 100);
  }
});

// Listen for custom events that might be fired by the theme
document.addEventListener('variant:change', updateFabricDetailsText);
document.addEventListener('variant:changed', updateFabricDetailsText);

/* =========================================== */
/* END DYNAMIC FABRIC DETAILS TEXT */
/* =========================================== */

/* =========================================== */
/* WCAG 2.1 AA ACCESSIBILITY FIX */
/* Fix focusable elements inside aria-hidden="true" */
/* =========================================== */
(function() {
  'use strict';

  const ARIA_HIDDEN_SELECTOR = '[aria-hidden]';
  const FOCUSABLE_SELECTOR = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
    '[contenteditable="true"]'
  ].join(',');
  const ORIGINAL_TABINDEX_ATTR = 'data-original-tabindex';

  function getFocusableElements(container) {
    return container.querySelectorAll(FOCUSABLE_SELECTOR);
  }

  function disableFocusableElements(container) {
    const focusableElements = getFocusableElements(container);
    focusableElements.forEach(function(element) {
      if (!element.hasAttribute(ORIGINAL_TABINDEX_ATTR)) {
        const currentTabindex = element.getAttribute('tabindex');
        if (currentTabindex !== null) {
          element.setAttribute(ORIGINAL_TABINDEX_ATTR, currentTabindex);
        } else {
          element.setAttribute(ORIGINAL_TABINDEX_ATTR, '');
        }
      }
      element.setAttribute('tabindex', '-1');
    });
  }

  function enableFocusableElements(container) {
    const focusableElements = getFocusableElements(container);
    focusableElements.forEach(function(element) {
      const originalTabindex = element.getAttribute(ORIGINAL_TABINDEX_ATTR);
      if (originalTabindex !== null) {
        if (originalTabindex === '') {
          element.removeAttribute('tabindex');
        } else {
          element.setAttribute('tabindex', originalTabindex);
        }
        element.removeAttribute(ORIGINAL_TABINDEX_ATTR);
      } else if (element.hasAttribute('tabindex') && element.getAttribute('tabindex') === '-1') {
        element.removeAttribute('tabindex');
      }
    });
  }

  function processElement(element) {
    const ariaHidden = element.getAttribute('aria-hidden');
    if (ariaHidden === 'true') {
      disableFocusableElements(element);
    } else if (ariaHidden === 'false' || ariaHidden === null) {
      enableFocusableElements(element);
    }
  }

  function processAllElements() {
    const allElements = document.querySelectorAll(ARIA_HIDDEN_SELECTOR);
    allElements.forEach(processElement);
  }

  function initAriaHiddenFix() {
    processAllElements();

    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
          processElement(mutation.target);
        }

        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType !== 1) return;
            if (node.hasAttribute('aria-hidden')) {
              processElement(node);
            }
            if (node.querySelectorAll) {
              node.querySelectorAll(ARIA_HIDDEN_SELECTOR).forEach(processElement);
            }
          });
        }
      });
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['aria-hidden'],
      childList: true,
      subtree: true
    });

    document.addEventListener('flickity:change', function() {
      requestAnimationFrame(processAllElements);
    });

    document.addEventListener('flickity:ready', function() {
      requestAnimationFrame(processAllElements);
    });

    document.addEventListener('shopify:section:load', function() {
      requestAnimationFrame(processAllElements);
    });

    document.addEventListener('shopify:section:reorder', function() {
      requestAnimationFrame(processAllElements);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(initAriaHiddenFix, { timeout: 3000 });
      } else {
        setTimeout(initAriaHiddenFix, 1);
      }
    });
  } else if ('requestIdleCallback' in window) {
    requestIdleCallback(initAriaHiddenFix, { timeout: 3000 });
  } else {
    setTimeout(initAriaHiddenFix, 1);
  }
})();
/* =========================================== */
/* END WCAG 2.1 AA ACCESSIBILITY FIX */
/* =========================================== */

/* =========================================== */
/* ACCESSIBLE NAME FOR HUBSPOT CTA DIALOGS */
/* HubSpot injects role="dialog" overlays without aria-label / aria-labelledby */
/* =========================================== */
(function() {
  'use strict';

  var DIALOG_SELECTOR = '[id^="hs-overlay-cta-"][role="dialog"], [role="dialog"].hs-cta-embed__loaded, [role="alertdialog"].hs-cta-embed__loaded';
  var FALLBACK_LABEL = 'Promotional offer';

  function hasAccessibleName(dialog) {
    if (dialog.hasAttribute('aria-label') && dialog.getAttribute('aria-label').trim()) return true;
    if (dialog.hasAttribute('aria-labelledby') && dialog.getAttribute('aria-labelledby').trim()) return true;
    return false;
  }

  function nameDialog(dialog) {
    if (!dialog || dialog.nodeType !== 1 || hasAccessibleName(dialog)) return;

    var heading = dialog.querySelector('h1, h2, h3, h4, h5, h6, [role="heading"]');
    if (heading) {
      if (!heading.id) {
        heading.id = dialog.id
          ? dialog.id + '-title'
          : 'hs-cta-dialog-title-' + Math.random().toString(36).slice(2, 9);
      }
      dialog.setAttribute('aria-labelledby', heading.id);
      return;
    }

    dialog.setAttribute('aria-label', FALLBACK_LABEL);
  }

  function nameAllDialogs(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches(DIALOG_SELECTOR)) {
      nameDialog(scope);
    }
    scope.querySelectorAll(DIALOG_SELECTOR).forEach(nameDialog);
  }

  function initHubspotDialogNames() {
    nameAllDialogs(document);

    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes') {
          var target = mutation.target;
          if (target.matches && target.matches(DIALOG_SELECTOR)) {
            nameDialog(target);
          }
          return;
        }

        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;
          nameAllDialogs(node);
        });
      });
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['role', 'class', 'id'],
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(initHubspotDialogNames, { timeout: 4000 });
      } else {
        setTimeout(initHubspotDialogNames, 1);
      }
    });
  } else if ('requestIdleCallback' in window) {
    requestIdleCallback(initHubspotDialogNames, { timeout: 4000 });
  } else {
    setTimeout(initHubspotDialogNames, 1);
  }
})();
/* =========================================== */
/* END HUBSPOT CTA DIALOG ACCESSIBLE NAME */
/* =========================================== */

/* =========================================== */
/* JUDGE.ME CAROUSEL: nested interactive + missing names
   Cards may be given role/tabindex while also containing product <a>s.
   Keep mouse click-to-lightbox; leave product links as the keyboard controls. */
/* =========================================== */
(function() {
  'use strict';

  var CARD_SELECTOR = '.jdgm-card.jdgm-carousel-item, .jdgm-card.jdgm-media-card';

  function demoteCard(card) {
    if (!card || card.nodeType !== 1) return;

    var role = card.getAttribute('role');
    if (role === 'button' || role === 'link') {
      card.removeAttribute('role');
    }

    if (card.getAttribute('tabindex') === '0') {
      card.setAttribute('tabindex', '-1');
    }

    // If Judge.me left a dialog-like name gap after demoting role=button, skip —
    // non-interactive cards do not need an accessible name.
  }

  function demoteAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches(CARD_SELECTOR)) {
      demoteCard(scope);
    }
    scope.querySelectorAll(CARD_SELECTOR).forEach(demoteCard);
  }

  function initJudgemeCarouselA11y() {
    demoteAll(document);

    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes') {
          if (mutation.target.matches && mutation.target.matches(CARD_SELECTOR)) {
            demoteCard(mutation.target);
          }
          return;
        }

        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;
          demoteAll(node);
        });
      });
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['role', 'tabindex'],
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(initJudgemeCarouselA11y, { timeout: 4000 });
      } else {
        setTimeout(initJudgemeCarouselA11y, 1);
      }
    });
  } else if ('requestIdleCallback' in window) {
    requestIdleCallback(initJudgemeCarouselA11y, { timeout: 4000 });
  } else {
    setTimeout(initJudgemeCarouselA11y, 1);
  }
})();
/* =========================================== */
/* END JUDGE.ME CAROUSEL A11Y */
/* =========================================== */
